import { memo } from 'react';
import { useTranslation } from '@aimsos/i18n';
import { Button, Tooltip } from '@aimsos/ui';

import { ChevronDown, ChevronUp } from 'lucide-react';

/**
 * "Collapse" / "Expand" for the summary cards, on the tab row as in the
 * prototype (CT-5713), with the tooltip that says what it folds (CT-5714).
 */
const SummaryCollapseToggle = memo(function SummaryCollapseToggle({ collapsed, onToggle }) {
  const { t } = useTranslation('unified-profiles');

  return (
    <Tooltip content={t('profile.summary.collapseTooltip')} size="compact" position="bottom">
      <Button
        variant="ghost"
        size="sm"
        rightIcon={collapsed ? ChevronDown : ChevronUp}
        aria-expanded={!collapsed}
        onClick={onToggle}
      >
        {collapsed ? t('profile.summary.expand') : t('profile.summary.collapse')}
      </Button>
    </Tooltip>
  );
});

export default SummaryCollapseToggle;
